import type { PayloadFormQuestion } from "@portal/app/_server/services/formFunnel/payloadTypes";
import {
  buildMutationVariables,
  transformValue,
} from "@portal/app/_components/formFunnel/results/hostedSteps/utils";
import { logger } from "@portal/app/_common/lib/logger";

type SaveVariables = Record<string, unknown>;

const toBool = (value: unknown): boolean => value === "true" || value === true;

const zipMapper = (value: unknown): SaveVariables => ({ address: { zip: String(value) } });

const FIELD_KEY_MAP: Record<string, (value: unknown) => SaveVariables> = {
  EDUCATION_LEVEL: (value) => ({ educationLevel: String(value) }),
  ZIP_CODE: zipMapper,
  TIMEFRAME_PREFERENCE: (value) => ({ timeframePreference: String(value) }),
  GRAD_YEAR: (value) => ({ graduatedHighSchoolIn: String(value) }),
  DATE_OF_BIRTH: (value) => ({ dob: String(value) }),
  IS_US_CITIZEN: (value) => ({ isUsCitizen: toBool(value) }),
  HAS_RN_LICENSE: (value) => ({ hasRNLicense: toBool(value) }),
  HAS_MILITARY_AFFILIATION: (value) => ({ hasMilitaryAffiliation: toBool(value) }),
  ENROLL_LIKELIHOOD: (value) => ({ enrollLikelihood: String(value) }),
  PROGRAM_ENVIRONMENT: (value) => ({ programEnvironment: String(value) }),
  ADDRESS_ZIP_ONLY: zipMapper,
};

export function buildSaveVariables(
  fieldKey: string,
  value: unknown,
  question?: PayloadFormQuestion
): SaveVariables | null {
  if (value === undefined || value === null || value === "") {
    return null;
  }

  const mapping = question?.customerFieldMapping;
  if (mapping?.enabled && mapping.customerField) {
    const transformedValue = transformValue(String(value), mapping.valueTransform || "none");
    return buildMutationVariables(mapping.customerField, transformedValue);
  }

  const mapper = FIELD_KEY_MAP[fieldKey];
  if (!mapper) {
    logger.info(`[buildSaveVariables] No static mapper for fieldKey=${fieldKey}, skipping`);
  }
  return mapper ? mapper(value) : null;
}
